<template>
  <div class="row">
    <div class="col-md-2">
      <div class="service-detail__container">
        <span class="service-title">Tipo de Servicio:</span>
        <p class="service-info">
          {{ value.serviceTypeName }}
        </p>
      </div>

      <div v-if="canShowLocationType" class="service-detail__container">
        <span class="service-title">Tipo de Lugar:</span>
        <p class="service-info">
          {{ value.locationTypeName }}
        </p>
      </div>
    </div>

    <div class="col-md-3">
      <div class="service-detail__container">
        <span class="service-title">Servicio/Actividad:</span>
        <p v-if="value.languageId === null" class="service-info">
          {{ value.disciplineTypeName }}
        </p>
        <p v-else class="service-info">
          {{
            value.disciplineTypeName +
              ' en idioma ' +
              value.languageName.toLowerCase()
          }}
        </p>
      </div>

      <div v-if="canShowSchoolType" class="service-detail__container">
        <span class="service-title">Tipo de Escuela:</span>
        <p class="service-info">
          {{ value.schoolTypeName }}
        </p>
      </div>
    </div>

    <div class="col-md-3">
      <div v-if="canShowEvaluationType" class="service-detail__container">
        <span class="service-title">Tipo de Evaluación:</span>
        <p class="service-info">
          {{ value.evaluationTypeName }}
        </p>
      </div>

      <div v-if="canShowModality" class="service-detail__container">
        <span class="service-title">Modalidad:</span>
        <p class="service-info">
          {{ value.serviceModalityTypeName }}
        </p>
      </div>

      <div v-if="canShowMunicipality" class="service-detail__container">
        <span class="service-title">Municipio:</span>
        <p class="service-info">
          {{ value.municipalityName }}
        </p>
      </div>
    </div>

    <div class="col-md-1">
      <div v-if="canShowDuration" class="service-detail__container">
        <span class="service-title">Duración:</span>
        <p class="service-info">
          {{ value.therapyDurationName }}
        </p>
      </div>

      <div class="service-detail__container">
        <span class="service-title">Costo:</span>
        <p class="service-info">{{ value.amount | price }}</p>
      </div>
    </div>

    <div class="col-md-2 d-flex justify-content-end align-items-center">
      <drop-down
        v-if="canPerformActions"
        :data-item="idx"
        :items="availableActions"
      />

      <div
        v-if="
          (canPerformActions && hasSelection) ||
            (userHasPermissions('provider.contract.service.addupdate') &&
              this.hasSelection)
        "
        class="select-service-item__container"
      >
        <CheckBox
          v-model="model.selected"
          class="select-service"
          :disabled="
            disabled &&
              !userHasPermissions('provider.contract.service.addupdate')
          "
        />
      </div>
    </div>
  </div>
</template>

<script>
import CheckBox from 'CheckBox';
import ServiceTypes from '@/utils/constants/serviceTypes.js';
import LocationTypes from '@/utils/constants/locationTypes';

export default {
  name: 'ProviderServiceResultRow',
  components: {
    CheckBox,
  },
  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({
        id: null,
        serviceType: null,
        serviceTypeName: null,
        evaluationTypeName: null,
        disciplineTypeName: null,
        serviceModalityType: null,
        serviceModalityTypeName: null,
        locationType: null,
        locationTypeName: null,
        municipalityId: null,
        municipalityName: null,
        therapyDuration: null,
        therapyDurationName: null,
        amount: null,
        selected: false,
      }),
    },
    idx: {
      type: Number,
      required: true,
    },
    hasSelection: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    editEnabled: {
      type: Boolean,
      default: false,
    },
    deleteEnabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      model: {
        selected: false,
      },
    };
  },
  computed: {
    canPerformActions() {
      return !this.disabled && (this.editEnabled || this.deleteEnabled);
    },
    availableActions() {
      let actions = [
        {
          name: 'edit',
          label: 'Editar',
          icon: 'fas fa-edit color-primary-1',
          click: () => this.$emit('edit', this.idx),
          visible: !this.disabled && this.editEnabled,
        },
        {
          name: 'delete',
          label: 'Eliminar',
          icon: 'fas fa-times-circle text-danger',
          click: () => this.$emit('delete', this.idx),
          visible: !this.disabled && this.deleteEnabled,
        },
      ];

      return actions;
    },
    canShowEvaluationType() {
      return this.value.serviceTypeId == ServiceTypes.AdditionalEvaluation;
    },
    canShowModality() {
      return this.value.serviceTypeId == ServiceTypes.Therapy;
    },
    canShowDuration() {
      return (
        this.value.serviceTypeId == ServiceTypes.Consultancy ||
        this.value.serviceTypeId == ServiceTypes.Therapy
      );
    },
    canShowLocationType() {
      return this.value.serviceTypeId == ServiceTypes.Therapy;
    },
    canShowSchoolType() {
      return this.value.locationTypeId == LocationTypes.Escuela;
    },
    canShowMunicipality() {
      return (
        this.value.serviceTypeId == ServiceTypes.Therapy ||
        this.value.serviceTypeId == ServiceTypes.AdditionalEvaluation ||
        this.value.serviceTypeId == ServiceTypes.IntitialEvaluation
      );
    },
  },
  watch: {
    'value.selected'(newValue) {
      this.model.selected = newValue;
    },
    'model.selected'(newValue) {
      this.$emit('toggle', {
        id: this.value.id,
        selected: newValue,
      });
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
@import '~@/shared/scss/config/fonts.scss';
@import '~@/shared/scss/config/colors.scss';

.service-detail__container {
  margin-top: 10px;
}

.service-title {
  color: map-get($colors, 'gray-6');
  font-size: map-get($fontsSize, 'font-14');
}

.service-info {
  color: map-get($colors, 'black');
  font-size: map-get($fontsSize, 'font-16');
  margin: 0;
}

.select-service-item__container {
  height: 100%;
  padding-left: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-left: 2px solid #ececec;
  margin-left: 30px;
}

.select-service {
  padding-left: 10px;
}
</style>
